import React from 'react'
import { ModalFuncProps } from 'antd'
import { getCharacterColor } from '@features/General/handlers'

export const imgExtensions = [
    'xbm',
    'tif',
    'pjp',
    'apng',
    'svgz',
    'ico',
    'tiff',
    'svg',
    'jfif',
    'webp',
    'bmp',
    'pjpeg',
    'avif',
    'png',
    'jpg',
    'jpeg',
    'gif'
]
export const videoExtensions = ['ogm', 'wmv', 'mpg', 'webm', 'ogv', 'mov', 'asx', 'mpeg', 'mp4', 'm4v', 'avi']
export const documentExtensions = ['dot', 'doc', 'xls', 'ppt', 'text', 'txt', 'pdf']
export const userGuideMapping = {
    '/matching/match_engine': 84899,
    '/matching/match-list': 84899,
    '/organizer': 84787,
    '/directory/published/companies': 85062,
    '/directory': 85062,
    '/responses': 85054,
    '/matching/match-list/details/': 85054,
    '/settings/event/info': 85066,
    '/analytics': 85063,
    '/trade-hub/pipeline': 85059,
    '/meetings/incoming': 85058,
    '/matching/matches/meeting-wish-list': 85055,
    '/view': 85052
}

/*
    Request statuses
 */
export const STATUS = {
    IDLE: 'idle',
    RUNNING: 'running',
    READY: 'ready',
    ERROR: 'error'
}

export const BREAKPOINTS = {
    XS: 480,
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
    XXL: 1600
}

export const modalConfig = params => {
    const { title, contentText, onOk, icon = null, okText = '', cancelText = '', onCancel, wrapClassName = '' } = params
    return {
        wrapClassName,
        title,
        icon,
        okButtonProps: {
            className: 'primary-solid'
        },
        okText: okText || title,
        onOk,
        cancelButtonProps: {
            className: 'secondary-ghost'
        },
        cancelText,
        content: <p>{contentText}</p>,
        onCancel
    } as ModalFuncProps
}

export enum COOKIE_KEYS {
    LANG = 'ALAEDDIN_LOCALE',
    ALA_TOKEN = 'ALA_TOKEN',
    ALA_DIRECTION = 'ALA_DIRECTION',
    ALA_REFRESH = 'ALA_REFRESH_TOKEN',
    ALA_USER_ROLE = 'ALA_USER_ROLE',
    ALA_USER_TYPE = 'ALA_USER_TYPE',
    ALA_EVENT = 'ALA_EVENT',
    ALA_COLOR = 'ALA_COLOR'
}

export enum LOCALSTORAGE_KEYS {
    USERINFO = 'userInfo',
    EVENT_LIST = 'EVENT_LIST',
    CONTACT_INFO = 'contactInfo',
    NAV_OPEN_KEYS = 'navOpenKeys',
    SIDE_BAR_THEME = 'sideBarTheme',
    SIDE_BAR_COLLAPSED = 'sideBarCollapsed',
    NOT_SUPPORT_POLLING = 'notSupportPolling',
    NAVIGATION_POSTION = 'navigationPosition',
    GMAIL_AUTH_CODE = 'gmailAuthCode',
    ONBOARDING_ORGANIZER = 'onboarding/organizer',
    ROCKET_CHAT_INFO = 'chatInfo',
    MENU_VISIBILITY = 'menuVisibility'
}

export const patternImagesWelcomeEmail = [
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/BlueWhiteSimpleConnectingEmailHeader_1.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/BlueWhiteSimpleConnectingEmailHeader_3.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/BlueWhiteSimpleConnectingEmailHeader_2.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/BlueWhiteSimpleConnectingEmailHeader_4.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/dots.jpeg',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/moroccan-flower.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/mosaic.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/triangle-mosaic.png',
    'https://aladdinb2b-event-branding-staging.s3.eu-west-1.amazonaws.com/defaultBGTemplates/webb.png'
]
export const generateAvatarByText = (title, size = 46) => {
    let initials = title?.substring(0, 2)
    const titleWords = title?.split(' ')
    if (titleWords?.length > 1) {
        initials = titleWords[0][0] || ''
        initials += titleWords[1][0] || ''
    }

    return (
        initials && (
            <div
                style={{
                    backgroundColor: getCharacterColor(title),
                    borderRadius: '50%',
                    width: size,
                    height: size,
                    fontSize: Math.floor((24 * size) / 46),
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <span>{initials.toUpperCase()}</span>
            </div>
        )
    )
}
